import * as React from "react";
import styled from "styled-components";

const GoogleMapContainer = styled.section`
  width: 90vw;
  height: 400px;
  position: relative;
  iframe {
    height: 400px;
    width: 90vw;
    border: 0;
    left: 0;
    top: 0;
    position: absolute;
  }
`;

const Map = () => {
  return (
    <GoogleMapContainer>
      <iframe
        title="google map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2520.5809240705707!2d3.8802995770847515!3d50.820402760656954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3a6606142b001%3A0x6f50b6cbdd15e276!2sBrambroek%201%2C%209500%20Geraardsbergen!5e0!3m2!1sen!2sbe!4v1710431711778!5m2!1sen!2sbe"
        width="600"
        height="400"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </GoogleMapContainer>
  );
};
export default Map;
